/** Some deps expect `process.env` in browser bundles. */
const globalWithProcess = globalThis as typeof globalThis & {
  process?: { env: Record<string, string | undefined> };
};

if (typeof globalWithProcess.process === 'undefined') {
  globalWithProcess.process = {
    env: {
      NODE_ENV: import.meta.env.MODE,
    },
  };
}
